import request, { METHODS } from '@/api'
import UrlConfig from '@/api/UrlConfigs'

/**
 * 获取客户管理列表
 */
export function getCustomerList(options: any) {
  return request(UrlConfig.crmManageWeb.GetCustomerList, {
    method: METHODS.POST,
    ...options,
  })
}

/**
 * 新增或编辑客户
 */
export function addOrEditCustomer(data: any) {
  return request(UrlConfig.crmManageWeb.AddOrEditCustomer, {
    method: METHODS.POST,
    data,
  })
}

/**
 * 获取客户详情
 */
export function getCustomerInfo(params: any) {
  return request(UrlConfig.crmManageWeb.GetCustomerInfo + '/' + params?.id, {
    method: METHODS.GET,
  })
}

/**
 * 根据id删除客户
 */
export function deleteCustomer(params: any) {
  return request(UrlConfig.crmManageWeb.GetCustomerInfo + '/' + params?.id, {
    method: METHODS.DELETE,
  })
}

/**
 * 查看联系人手机号码
 */
export function getContactPhonesByld(id: string) {
  return request(`${UrlConfig.crmManageWeb.getContactPhonesByld}/${id}`, {
    method: METHODS.GET,
  })
}
/**
 * 查看客户电话
 */
export function viewPhone(id: string, key: string) {
  return request(UrlConfig.crmManageWeb.viewPhone + '/' + id + '/' + key, {
    method: METHODS.GET,
  })
}

/**
 * 查看客户微信
 */
export function viewWeChat(id: string, key: string) {
  return request(UrlConfig.crmManageWeb.viewWeChat + '/' + id + '/' + key, {
    method: METHODS.GET,
  })
}

/**
 * 获取客户商机
 */
export function getCustomerTrackPlan(data: any) {
  return request(UrlConfig.crmManageWeb.GetCustomerTrackPlan, {
    method: METHODS.POST,
    data,
  })
}

/**
 * 获取客户跟进记录
 */
export function getCustomerFollowRecord(data: any) {
  return request(UrlConfig.crmManageWeb.GetCustomerFollowRecord, {
    method: METHODS.POST,
    data,
  })
}